import nyTack from './modules/ny-tack/ny-tack';
import nyQuestions from './modules/ny-questions/ny-questions';
import app from '../shared/shared';

/**
 * register the modules that should be
 * bootstrapped.
 */

app.registerModules([
  nyQuestions,
  nyTack,
]);
